import { translate } from 'utils/translate';

export const getOrderLabel = (ordersAmount: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(ordersAmount);
   return grammaticalNumber === 'one'
      ? translate('labels.order_one')
      : translate('labels.address_many');
};
